import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StoryCard from "./StoryCard";
import SkeletonStoryCard from "./skeletonStoryCard";
import '../../styles/global.css'
import '../../styles/common.css'
import LatestList from "./latestList";
import LatestNews from "./latestNews";

function Section({ title, slug, items }) {
  return (
    <section>
      <div className="section-title">
      <h2>{title}</h2>
       {title && title !== 'Trending' && <Link to={`/${slug}`}>View More »</Link>}
      </div>
      <div className="stories-grid">
        {items.map((s, index) => (
          <StoryCard key={s.story_id || index} story={s} />
        ))}
      </div>
    </section>
  );
}

function SkeletonSection() {
  return (
    <section>
      <div className="section-title">
      <h2>Trending</h2>
       {/* {title && title !== 'Trending' && <Link to={`/${slug}`}>View More »</Link>} */}
      </div>
      <div className="stories-grid">
        {[0,0,0].map((s, index) => (
          <SkeletonStoryCard key={index}  />
        ))}
      </div>
    </section>
  );
}

export default function Home({data}) {

  
            const ssrData = data?.[0]?.homeData || {}
            

  return (
    <div className="main-container">
      <div className="home-layout">
        
        
        <aside className="home-sidebar shadow-lg">
          <h3>Latest news</h3>
          <LatestNews />
        </aside>
         <SectionMaster   ssrWebStories ={ssrData.home_web_stories} ssrCategoryWebStories={ssrData.home_category_web_stories} />
         <aside className="home-sidebar shadow-lg">
             <div className="sidebar-widget">
          <div className="widget-header">
            <h3>Latest Pics</h3>
          </div>
          <LatestList />
        </div>
         </aside>
        
      </div>
    </div>
  );
}

let hasHydratedOnce = false;

const SectionMaster = ({ssrWebStories, ssrCategoryWebStories}) => {
      
          const [trending,setTrending] = useState(ssrWebStories)
          const [all,setAll]           = useState(ssrCategoryWebStories)
          const [loading,setLoading]   = useState(false)
          const [error,setError]       = useState(null)

   useEffect(()  =>  {


    if ( !hasHydratedOnce && trending?.length > 0 && all?.length > 0) {
         hasHydratedOnce = true;
         setLoading(false)
         return;
    }


      const loadData = async () => {
     

      try {
        const [trendingRes, allRes] = await Promise.all([
          fetch(
            `https://www.teluguone.com/news_api/newsAllWebStoresJson`,
            {
              cache: "no-store",
            }
          ),
          fetch(
            `https://www.teluguone.com/news_api/newsAllCategoryiesWStoresJson`,
            {
              cache: "no-store",
            }
          ),
        ]);

        if (!trendingRes.ok) {
          throw new Error("trending fetch failed");
        }

        const trendingJson = await trendingRes.json();
        if (!allRes.ok) {
              throw new Error("all fetch failed");
            }
        const allJson = await allRes.json();

       const trendingData = Array.isArray(
  trendingJson?.home_web_stories
)
  ? trendingJson.home_web_stories
  : [];

const allData = Array.isArray(
  allJson?.home_category_web_stories
)
  ? allJson.home_category_web_stories
  : [];

        setTrending(trendingData)
        setAll(allData)
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
       };
        
       setTrending(null)
       setAll(null)
       setLoading(true);
       loadData();

   },[])

    if(loading) {
        return <SkeletonSection />
    }
    if (error) {
        return <div>No Data</div>
    }

    return  <div>
        {trending && <Section title="Trending" slug="trending" items={trending} /> }
        {all && all.map((item,index)  => <Section key={index} title={item.category} slug={item.category?.toLowerCase()} items={item.stories} />) }
    </div>

}